import { render, staticRenderFns } from "./CommandCenter.vue?vue&type=template&id=c80b4c3c&scoped=true&"
import script from "./CommandCenter.vue?vue&type=script&lang=js&"
export * from "./CommandCenter.vue?vue&type=script&lang=js&"
import style0 from "./CommandCenter.vue?vue&type=style&index=0&id=c80b4c3c&prod&lang=scss&scoped=true&"
import style1 from "./CommandCenter.vue?vue&type=style&index=1&id=c80b4c3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80b4c3c",
  null
  
)

export default component.exports